// Plus Jakarta Sans - bundled locally, no Google Fonts (for offline/etisalat deployment)
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';

import { CssBaseline, ThemeProvider } from '@mui/material';

import { useAppTheme } from '@shared/theme/Theme';
import { RootState, useAppSelector } from '@shared/store';
import RTL from '@shared/layouts/FullLayout/shared/customizer/RTL';
import ScrollToTop from '@shared/components/shared/ScrollToTop';
import { DayjsProvider } from './dayjs';
import { Router } from './router';
import { AccessModal } from '@widgets/Popup/AccessModal/AccessModal';
import { isAccessModalEnabled } from '@shared/utils/env';
import { AppToastContainer } from '@shared/components/AppToastContainer';

const App = () => {
  const theme = useAppTheme();
  const customizer = useAppSelector((state: RootState) => state.customizer);

  return (
    <ThemeProvider theme={theme}>
      {isAccessModalEnabled && <AccessModal />}
      <DayjsProvider>
        <RTL direction={customizer.activeDir ?? 'ltr'}>
          <CssBaseline />
          <ScrollToTop>
            <Router />
          </ScrollToTop>
          <AppToastContainer />
        </RTL>
      </DayjsProvider>
    </ThemeProvider>
  );
};

export default App;
